import { useGetDepotsQuery } from "./useGetDepotsQuery";

export const useGetDepotById = (id: number) => {
  const { data } = useGetDepotsQuery();

  return data?.resources.find(depot => depot.id === id);
};
